<div class="flex h-full flex-col gap-4 p-4">
  <!-- PDF Actions Menu -->
  <div class="flex justify-end">
    <button
      mat-icon-button
      [matMenuTriggerFor]="pdfMenu"
      [disabled]="isActionDisabled()"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #pdfMenu="matMenu">
      <button
        mat-menu-item
        [disabled]="isActionDisabled()"
        (click)="onPreview()"
      >
        @if (isGenerating()) {
          <mat-spinner diameter="20" class="mr-2" />
        } @else {
          <mat-icon>visibility</mat-icon>
        }
        <span>Preview Letter</span>
      </button>
      <button
        mat-menu-item
        [disabled]="isActionDisabled()"
        (click)="onDownload()"
      >
        <mat-icon>download</mat-icon>
        <span>Download Letter</span>
      </button>
    </mat-menu>
  </div>

  <!-- Header/Footer Templates -->
  <div class="rounded-lg border border-slate-200 bg-white p-4">
    <h3 class="mb-3 text-sm font-medium text-slate-700">PDF Templates</h3>
    @if (printTemplates().length > 0) {
      <pr-system-template-selectors
        [templates]="printTemplates()"
        [hideHeaders]="true"
        [useTooltipHints]="true"
        (templateChange)="onTemplatesChange($event)"
      />
    } @else {
      <p class="text-sm text-slate-500">No print templates configured</p>
    }
  </div>

  <mat-divider />

  <!-- Patient Email & Send -->
  <div class="rounded-lg border border-slate-200 bg-white p-4">
    <h3 class="mb-2 text-sm font-medium text-slate-700">Send to Patient</h3>
    @if (hasPatientEmail()) {
      <p class="mb-3 text-sm text-slate-600">
        <mat-icon class="icon-sm mr-1 align-middle">email</mat-icon>
        {{ patientEmail() }}
      </p>
    } @else {
      <p class="mb-3 text-sm text-red-500">
        <mat-icon class="icon-sm mr-1 align-middle">warning</mat-icon>
        No email address on file
      </p>
    }
    <button
      mat-flat-button
      color="primary"
      class="w-full"
      [disabled]="!hasPatientEmail() || isActionDisabled()"
      [matTooltip]="noEmailTooltip()"
      (click)="onSend()"
    >
      <span class="flex w-full items-center justify-center gap-2">
        @if (isSending()) {
          <mat-spinner diameter="20" />
          Sending...
        } @else {
          <ng-container>
            <mat-icon class="icon-sm">send</mat-icon>
            Send to Patient
          </ng-container>
        }
      </span>
    </button>
  </div>
</div>
